import './index.css'

const PasswordItem = props => {
  const {passwordDetails, showPasswords, onDeletePassword} = props

  const {id, website, username, password} = passwordDetails

  const onDelete = () => {
    onDeletePassword(id)
  }

  return (
    <li className="password-item">
      <div className="website-letter">{website[0].toUpperCase()}</div>

      <div className="password-details">
        <p className="password-text">{website}</p>

        <p className="password-text">{username}</p>

        {showPasswords ? (
          <p className="password-text">{password}</p>
        ) : (
          <img
            src="https://assets.ccbp.in/frontend/react-js/password-manager-stars-img.png"
            alt="stars"
            className="stars-image"
          />
        )}
      </div>

      <button
        type="button"
        className="delete-button"
        data-testid="delete"
        onClick={onDelete}
      >
        <img
          src="https://assets.ccbp.in/frontend/react-js/password-manager-delete-img.png"
          alt="delete"
          className="delete-image"
        />
      </button>
    </li>
  )
}

export default PasswordItem
